module.exports = __webpack_public_path__ + "static/media/500Error.5a873174.png";